// extracted by mini-css-extract-plugin
export default {"container":"ServiceSummaryModal_container__gmkE5","body":"ServiceSummaryModal_body__pB3RB","card":"ServiceSummaryModal_card__UGC54","cardBody":"ServiceSummaryModal_cardBody__wrQhH"};